/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyright': 'Desenvolvido pelo Atlassian Intelligence',
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyrightShort': 'Impulsionado pelo AI',
  'fabric.editor.ai.commandPalette.footer.disclaimerText':
    'O conteúdo é baseado nas permissões e a qualidade pode variar',
  'fabric.editor.ai.commandPalette.footer.disclaimerTextShort': 'A qualidade do conteúdo pode variar',
  'fabric.editor.ai.commandPalette.footer.disclaimerTextUpdated':
    'Utiliza a inteligência artificial Verifique os resultados.',
  'fabric.editor.ai.commandPalette.footer.infoIconLabel': 'Informações',
  'fabric.editor.ai.commandPalette.footer.rovoCopyright': 'Rovo',
  'fabric.editor.ai.commandPalette.footer.usePageKnowledgeToggleLabel': 'Inclua conhecimento da página atual',
  'fabric.editor.ai.commandPalette.promptForm.logo': 'Logotipo da Atlassian Intelligence',
  'fabric.editor.ai.components.backIconButton.backLabel': 'Voltar',
  'fabric.editor.ai.components.cancelEscButton.cancelLabel': 'Cancelar',
  'fabric.editor.ai.components.cancelEscButton.escLabel': 'Esc',
  'fabric.editor.ai.components.cancelIconButton.cancelLabel': 'Cancelar',
  'fabric.editor.ai.components.cancelIconButton.cancelTooltip': 'Cancelar',
  'fabric.editor.ai.components.feedbackForm.badResponse': 'Resposta ruim',
  'fabric.editor.ai.components.feedbackForm.feedbackSent': 'Feedback enviado',
  'fabric.editor.ai.components.feedbackForm.goodResponse': 'Boa resposta',
  'fabric.editor.ai.config.item.action.continueFromLatestResponse': 'Continuar a partir da última resposta',
  'fabric.editor.ai.config.item.action.copyResponse': 'Copiar',
  'fabric.editor.ai.config.item.action.responseCopied': 'Copiado!',
  'fabric.editor.ai.config.item.action.responseCopiedToClipboard': 'Copiado para a área de transferência',
  'fabric.editor.ai.config.item.action.retryPrompt': 'Tentar de novo',
  'fabric.editor.ai.experience-application.documentInsertError':
    'A gente está com problemas para inserir a resposta. Feche a caixa de diálogo e tente de novo.',
  'fabric.editor.ai.experience-application.tokenLimitExceeded':
    'Não foi possível obter uma resposta. A solicitação ou resposta estava acima do limite dessa solicitação. Feche a caixa de diálogo e tente de novo.',
  'fabric.editor.ai.experience.apiError': 'Não foi possível obter uma resposta. Tente de novo.',
  'fabric.editor.ai.experience.commandPaletteAriaName': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.inputTooShortError':
    'O conteúdo é curto demais para ser resumido. Adicione mais e tente de novo.',
  'fabric.editor.ai.experience.loadingAriaTitle': 'Gerando',
  'fabric.editor.ai.experience.previewScreenLabel': 'Pré-visualizar',
  'fabric.editor.ai.experience.rovoAgents.agentPalette.placeholder':
    'Diga ao agente algo para escrever ou escolha uma das opções abaixo',
  'fabric.editor.ai.experience.rovoAgents.productLabel': 'Rovo',
  'fabric.editor.ai.experience.rovoAgents.productLogoAltText': 'Logotipo do Rovo',
  'fabric.editor.ai.screens.UserInputCommamdPalette.footerText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.discard.cancelLabel': 'Voltar',
  'fabric.editor.ai.screens.discard.discardLabel': 'Descartar',
  'fabric.editor.ai.screens.error.warningIconLabel': 'Aviso',
  'fabric.editor.ai.screens.error.ariaErrorTitle': 'Erro',
  'fabric.editor.ai.screens.error.cancelLabel': 'Cancelar',
  'fabric.editor.ai.screens.error.retryLabel': 'Tentar de novo',
  'fabric.editor.ai.screens.loading.adfContentAriaLiveRegionDescription': 'Conteúdo de atualização ao vivo:',
  'fabric.editor.ai.screens.loading.iconAltText': 'Ícone de geração',
  'fabric.editor.ai.screens.preview.betaLabel': 'Beta',
  'fabric.editor.ai.screens.preview.cancelLabel': 'Cancelar',
  'fabric.editor.ai.screens.preview.defaultAIPlaceholder': 'Diga ao AI o que fazer a seguir',
  'fabric.editor.ai.screens.preview.discardLabel': 'Descartar',
  'fabric.editor.ai.screens.preview.disclaimer': 'A qualidade das informações pode variar.',
  'fabric.editor.ai.screens.preview.disclaimerLink': 'Saiba por que',
  'fabric.editor.ai.screens.preview.header.clear.hover': 'Limpar',
  'fabric.editor.ai.screens.preview.header.edit': 'Editar prompt',
  'fabric.editor.ai.screens.preview.header.edit.hover': 'Editar',
  'fabric.editor.ai.screens.preview.placeholderWithAgent': 'Pergunte a {agentName} o que fazer a seguir',
  'fabric.editor.ai.screens.preview.refineButton': 'Refinar',
  'fabric.editor.ai.screens.preview.refineDropdown.refineButton': 'Refinar',
  'fabric.editor.ai.screens.prompt.logoAltText': 'Logotipo da Atlassian Intelligence',
  'fabric.editor.ai.screens.prompt.logoText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.prompt.submitLabel': 'Enviar',
  'fabric.editor.ai.screens.prompt.submitTooltip': 'Enviar para o AI',
  'fabric.editor.ai.screens.promptWithSelectedOption.promptSelected': '{promptName} selecionado',
  'fabric.editor.ai.screens.promptWithSelectedOption.removeLabel': 'Remover',
  'fabric.editor.ai.shared.aiProactiveButtonLabel': 'Sugestões',
  'fabric.editor.ai.shared.aiUniversalDescriptor': 'Assistente de redação',
  'fabric.editor.ai.shared.aiUniversalLongCallToAction': 'Deixe o Atlassian Intelligence ajudar você a escrever',
  'fabric.editor.ai.shared.aiUniversalShortCallToAction': 'Escrever',
  'fabric.editor.ai.shared.betaLabel': 'Beta',
  'fabric.editor.ai.shared.generateContent.aiButtonTitle': 'AI (Atlassian Intelligence)',
  'fabric.editor.ai.ui.components.suggestions.betaLozenge': 'BETA',
  'fabric.editor.ai.ui.components.suggestions.newLozenge': 'NOVIDADE',
  'fabric.editor.ai.ui.components.suggestions.tellAILabel': 'Diga ao AI:',
  'fabric.editor.ai.ui.components.suggestions.tellAgentLabel': 'Diga ao agente',
};
